<template>
<v-card class="panel"  elevation="1">
    <div class="subscriptions">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.payments || "Payments" }}</h2>
            </div>
            <div class="right" v-if="$page.props.p['members.payments.make']">
                <v-btn @click="openNewTransactionModal()" color="primary" dark>
                    <v-icon small class="mr-2">mdi-plus</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp">{{ $page.props.lang.addPayment || "Add payment" }}</span>
                </v-btn>
            </div>
        </div>
      
        <div class="totals">
            <div class="total">
                <div class="icon"><v-icon>mdi-cash-register</v-icon></div>
                <div class="data">
                    <h4 class="amount">
                        {{ Number.parseFloat(member.total_payments).toFixed(2) }}
                        <span>{{ organization.settings.currency }}</span>
                    </h4>
                    <div class="info-title">{{ $page.props.lang.paymentsTotal || 'Payments total' }}</div>
                </div>
            </div>
            <div class="total">
                <div class="icon"><v-icon>mdi-plus-minus-box</v-icon></div>
                <div class="data">
                    <h4 class="amount" v-if="member.total_balance < 0" style="color:#f23d55">
                        {{ Number.parseFloat(member.total_balance).toFixed(2) }}
                        <span>{{ organization.settings.currency }}</span>
                    </h4>
                    <h4 class="amount" v-else style="color:#4ede77">
                        {{ Number.parseFloat(member.total_balance).toFixed(2) }}
                        <span>{{ organization.settings.currency }}</span>
                    </h4>
                    <div class="info-title">{{ $page.props.lang.balance || 'Balance' }}</div>
                </div>
            </div>
        </div>
        <div class="table-container">
            <v-data-table
            :headers="paymentsHeaders"
            :items="memberData.payments"
            :page.sync="tablePage"
            :items-per-page="itemsPerPage"
            @page-count="tablePageCount = $event"
            item-key="item.id"
            mobile-breakpoint="0"
            hide-default-footer>
                <template v-slot:item.created_at="{ item }">
                    {{ item.transaction_date | formatDate }}
                </template>
                <template v-slot:item.period="{ item }">
                   {{ item.subscription_name }}<br>
                   {{ item.subscription_period}}
                </template>
                <template v-slot:item.description="{ item }">
                    {{ item.description }}
                </template>
                <template v-slot:item.paid="{ item }">
                    <p class="amount">
                        {{ item.paid }} <span class="table-currency">{{ item.currencyPaid }}</span>
                    </p>
                </template>
                <template v-slot:item.action="{ item }">
                    <v-btn @click="openEditModal(item)" :loading="item.loading" :id="'edit' + item.id" v-show="$page.props.p['members.payments.make']" class="edit-icon" icon>
                        <v-icon>mdi-pencil</v-icon>
                        <v-tooltip :activator="'#edit'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.editPayment || "Edit"}}</span>
                        </v-tooltip>
                    </v-btn>
                    <v-btn @click="deleteSelected(item)"  color="red" :id="'delete' + item.id" v-show="$page.props.p['members.payments.make']" icon>
                        <v-icon>mdi-delete</v-icon>
                        <v-tooltip :activator="'#delete'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.deletePayment || "Delete"}}</span>
                        </v-tooltip>
                    </v-btn>
                </template>
            </v-data-table>
        </div>
        <v-dialog
        v-model="editModal"
        max-width="500px">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.editTransaction || "Edit transaction" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="editModal = false"><v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
                <v-card-text>
                  <v-container>
                      <div class="fields">
                           <div class="grid">
                               <label class="custom-label">{{ $page.props.lang.linkedMembership || "Linked Membership" }}</label>
                                <v-select
                                        v-model="currentTransaction.period_id"
                                        :items="periods"
                                        menu-props="auto"
                                        item-text="title"
                                        item-value="id"
                                        outlined
                                        dense
                                        ></v-select>
                                <p class="custom-label">{{ $page.props.lang.amount|| 'Amount' }}</p>
                                <v-text-field v-model="currentTransaction.amount"
                                    :suffix="$page.props.organization.settings.currency"
                                    outlined dense
                                    :error-messages="responseErrors.amount" @focus="responseErrors.amount=''"></v-text-field>
                                <p class="custom-label">{{ $page.props.lang.description || 'Description' }}</p>
                                <v-textarea v-model="currentTransaction.description" outlined dense rows="2" hide-details></v-textarea>
                                    
                                <p class="custom-label">{{ $page.props.lang.date || 'Date' }}</p>
                                 <v-menu
                                    ref="menu"
                                    v-model="editTransactionDatePicker"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y 
                                    min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field 
                                            :value="currentTransaction.transaction_date | formatDate" 
                                            append-icon="mdi-menu-down" 
                                            outlined dense hide-details 
                                            readonly v-bind="attrs" v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="currentTransaction.transaction_date" 
                                         no-title scrollable color="primary">
                                            <v-spacer></v-spacer>
                                            <v-btn color="regular" @click="editTransactionDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                            <v-btn color="primary" @click="editTransactionDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                   
                            </div>  
                      </div>
                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="regular" @click="editModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                          <v-btn color="primary" @click="editTransaction">{{ $page.props.lang.save || "Save" }}</v-btn>
                      </v-card-actions>
                  </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <ConfirmDelete 
        :open="deleteTransactionModal" 
        @no="deleteTransactionModal = false" 
        @close="deleteTransactionModal = false"
        @yes="deleteTransaction"></ConfirmDelete>

        <PaymentModal v-if="PaymentModal"
        :modal="PaymentModal"
        :member_id="member.id"
        :period_id="null"
        :payment_types="this.paymentTypes"
        @close="PaymentModal = false">
        </PaymentModal>

    </div>
</v-card>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import MemberLayout from './Layouts/Default'
import ConfirmDelete from '@/js/Components/ConfirmDelete'
import ConfirmModal from '@/js/Components/ConfirmModal'
import PaymentModal from '@/js/Components/PaymentModal'
import EventBus from '@/js/eventbus'

export default {
    metaInfo() {
        return {
            title: this.$page.props.member.full_name + ' - ' + (this.$page.props.lang.title || "Payments")
        }
    },
	name: "MemberPayments",
	components: {
		ConfirmDelete,
        ConfirmModal,
        PaymentModal
	},
    layout: (h, page) => {
      return h(AppLayout, [
        h(MemberLayout, [page]),
      ])
    },
    props: {
        member: Object,
        errors: Object,
        lang: Object,
        organization: Object,
        paymentTypes: Array
    },
	data() {
		return {
            memberData: this.member,
            totalCharges: 0,
            totalPayments: 0,
            periods: [],
            totalDue: 0,
            date: moment().format('YYYY-MM-DD'),
            paymentsHeaders: [
                {text: this.lang.date || 'Transaction date', value: 'transaction_date', sortable: false, align: 'start'},
                {text: this.lang.subscription || 'Subscription', value: 'period', sortable: false, align: 'left'},
                {text: this.lang.description || 'Description', value: 'description', sortable: false, align: 'center'},
                {text: this.lang.paid || 'Paid', value: 'paid', sortable: false, align: 'right'},
                {text: this.lang.action || 'Action', value: 'action', sortable: false, align: 'end', width: '164px'}
            ],
            savingPayment: false,
            payModal: false,
            PaymentModal:false,
            resetForm: {
                amount: '',
                description: ''
            },
            tablePage: 1,
            tablePageCount: 0,
            itemsPerPage: 8,
            payment: {},
            messageObjects: [],
            responseErrors: {},
            deleteSelectedId: null,
            deleteTransactionModal: false,
            currentTransaction: {},
            editModal: false,
            editTransactionDatePicker: false,
            loading: [],
            payModalLoading: false
        }
    },
    created() {
        this.setupTable()
        this.setupTotals()

        EventBus.$on('CLOSE_PAYMENT_MODAL', (p) => {

            this.$inertia.reload()
            this.PaymentModal = false;
        })
    },
    watch: {
        member: function(value) {
            this.memberData = value
            this.setupTable()
            this.setupTotals()
        },
        payModal: function(value) {
            if (value===false) {
                this.responseErrors = {}
                this.payment = Object.assign({}, this.resetForm)
            }
        }
    },
    
    methods: {
        setupTotals() {
            if (this.member.totals) {
                this.memberData.totals.forEach(item => {
                    item.type === 0 ? this.totalCharges = item.total_amount : this.totalPayments = item.total_amount
                })
                this.totalDue = this.totalPayments - this.totalCharges
               // this.totalDue > 0 ? this.totalDue = this.totalDue : this.totalDue = 0
            }
        },

        setupTable() {
            this.memberData.payments.forEach(item => {
                if (item.type===0) {
                    item.charged = item.amount
                    item.paid = '-'
                    item.currencyPaid = ''
                    item.currencyCharged = this.organization.settings.currency
                } else {
                    item.charged = '-'
                    item.paid = item.amount
                    item.currencyPaid = this.organization.settings.currency
                    item.currencyCharged = ''
                }
            })
        },
        openNewTransactionModal(){
            this.PaymentModal = true;
        },
     
        deleteSelected(item) {
            this.deleteSelectedId = item.id;
            this.deleteTransactionModal = true;
        },
        deleteTransaction() {
            axios.post('/backoffice/members/deleteTransaction', {id: this.deleteSelectedId, member_id: this.member.id})
                .then(response => {   
                    if(response.data.status==="OK") {
                        this.deleteTransactionModal = false
                        this.$inertia.reload({only:['member']})
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                        
                    }
                })
                .catch(error => {                  
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        },
        openEditModal(item){
            
            item.loading = true;
             
            axios.get('/backoffice/members/getTransaction/'+ item.id + '/'+ this.member.id)
                .then(response => {
                    item.loading = false;
                    if(response.data.status === "OK"){
                        this.editModal = true
                        this.currentTransaction = response.data.transaction;
                        this.periods = response.data.periods;
                    }else{
                        alert(response.data.message)
                    }
                })
                .catch(error => {
                    item.loading = false;
                });
        },
        editTransaction(){
            
            axios.post('/backoffice/members/updateTransaction', this.currentTransaction)
                .then(response => {
                    if(response.data.status==="OK") {
                        this.$inertia.reload({only:['member']})
                       EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                      this.editModal = false
                    }
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                });
        }
    }
}
</script>
